export class Utils {
    public static arraysEqual(arr1: string[], arr2: string[]) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (let i = arr1.length; i--;) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    }

    public static convertToDays(value: string) {
        try {
            const dateDiff = (startDate: Date) => {
                const currentDate = new Date();
                return Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())) / (1000 * 60 * 60 * 24));
            };

            const date = new Date();
            switch (value) {
                case '1 week':
                    return 7;
                case '2 weeks':
                    return 14;
                case '1 month':
                    date.setMonth(date.getMonth() - 1);
                    return dateDiff(date);
                case '3 months':
                    date.setMonth(date.getMonth() - 3);
                    return dateDiff(date);
                case '6 months':
                    date.setMonth(date.getMonth() - 6);
                    return dateDiff(date);
            }
        } catch {}
        return;
    }

    public static getSupportArticleUrl(source: string) {
        const articleUrlEnvVariable = `REACT_APP_SupportArticle${source}`;
        const supportArticleUrl = process.env[articleUrlEnvVariable];
        return supportArticleUrl;
    }
}



// WEBPACK FOOTER //
// ./src/Utils.tsx